import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mention',
  standalone: false,
})
export class MentionPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    const mentionRegex = /(@(?!medullar\b)\w+( \w+)?|@medullar\b)/g;

    const styledHtml = value.replace(mentionRegex, (match) => {
      return `<span class="med-mention">${match}</span>`;
    });
    return styledHtml;
  }
}
